export default "__VITE_ASSET__jbDpNXB9__"